<template>
  <form
    ref="form"
    data-url="/technicalReviewer/observationActivity/samplingPlanFile"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Documentación anterior</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-middle">Propuesta del equipo evaluador</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  Ver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <hr />
      <div class="col-6">
        <div class="form-group">
          <label>Plan de muestreo*:</label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            v-if="!inputs.sampling_plan_file"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'sampling_plan_file')"
              v-if="inputs.sampling_plan_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('sampling_plan_file')"
              v-if="inputs.sampling_plan_file"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>

        <div class="form-group">
          <label>Otro archivo(Opcional)</label>
          <app-input
            type="textarea"
            v-model="inputs.other_file507_description"
            placeholder="Ingrese la descripción"
          />
          <app-input
            type="file"
            :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
            v-model="inputs.file_2"
            v-if="!inputs.other_file507"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'other_file507')"
              v-if="inputs.other_file507"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('other_file507')"
              v-if="inputs.other_file507"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
// import * as actions from "../../../../apiUrl";
export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
      observation: "",
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
      this.loadForm2();
    },
  },

  created() {
    this.loadForm();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    observationList() {},

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          file_evaluation:
            this.$store.state.evaluatorReview.evalTest.file_evaluation,
          sampling_plan_file:
            this.$store.state.evaluatorReview.evalTest.sampling_plan_file,
          other_file507:
            this.$store.state.evaluatorReview.evalTest.other_file507,
        };
      }
    },
    loadForm2() {
      if (
        this.$store.state.evaluatorReview.evalTest.observations_evaluation_team
      ) {
        if (
          this.$store.state.evaluatorReview.evalTest
            .observations_evaluation_team
        ) {
          for (
            let index = 0;
            index <
            this.$store.state.evaluatorReview.evalTest
              .observations_evaluation_team.length;
            index++
          ) {
            if (
              this.$store.state.evaluatorReview.evalTest
                .observations_evaluation_team[index].status.code == "507"
            ) {
              this.observation =
                this.$store.state.evaluatorReview.evalTest.observations_evaluation_team[
                  index
                ].observation;
            }
          }
        }

        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          testification_evaluation_questionnaire:
            this.$store.state.evaluatorReview.evalTest
              .testification_evaluation_questionnaire,
          file_evaluation:
            this.$store.state.evaluatorReview.evalTest.file_evaluation,
          other_file507_description: this.observation,

          sampling_plan_file:
            this.$store.state.evaluatorReview.evalTest.sampling_plan_file,
          other_file507:
            this.$store.state.evaluatorReview.evalTest.other_file507,
        };
      }
    },
  },
};
</script>